import { render, staticRenderFns } from "./bookingSlots.vue?vue&type=template&id=1ccb9085"
import script from "./bookingSlots.vue?vue&type=script&lang=js"
export * from "./bookingSlots.vue?vue&type=script&lang=js"
import style0 from "./bookingSlots.vue?vue&type=style&index=0&id=1ccb9085&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports